import template from './add-premium/add.premium.dialog.html';
import AddPremiumDialogController from './add-premium/add.premium.dialog.controller';

function premiumFactory($http, $mdDialog, Product) {
  function showAddDialog() {
    $mdDialog.show({
      template,
      controller: AddPremiumDialogController,
      controllerAs: '$ctrl',
      resolve: {
        products() {
          return Product.getAll();
        },
      },
    });
  }
  function add({
    post, product, days, isAds = false, category,
  }) {
    return $http
      .post('/admin/premium', {
        post,
        product,
        days,
        isAds,
        category,
      })
      .then(response => response.data);
  }
  function get(position) {
    return $http.get('/admin/premium', { params: { position } }).then(response => response.data);
  }
  return { showAddDialog, get, add };
}
premiumFactory.$inject = ['$http', '$mdDialog', 'Product'];
export default premiumFactory;



// WEBPACK FOOTER //
// ./client/app/components/premium/premium.factory.js